import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {WIDGETS_PARAMS_RESOURCE} from "../../../core/consts";

export class EntitiesRecognizerRequestParams extends BaseApiRequestParams {
  url: Array<Number>;
  paramsResource: WIDGETS_PARAMS_RESOURCE;

  constructor(paramsResource: WIDGETS_PARAMS_RESOURCE, url: String = '') {
    super('');

    this.usePrefix = false;
    this.paramsResource = paramsResource;
    this.url = encodeURIComponent(url);
  }

  get urlParam() {
    return `url=${this.url}`;
  }

  get langParam() {
    return this.initialParams?.langId > 0 ? `&lang=${this.initialParams.langId}` : '';
  }

  get prefix() {
    const prefix: String = this.paramsResource === WIDGETS_PARAMS_RESOURCE.url ? 'https://partners-entities-recognizer.365scores.com/?' : `https://entities-recognizer.365scores.com/analyze_url/?`;

    return prefix;
  }

  toString(): string {
    return this.prefix + this.urlParam + this.langParam;
  }

  equals(model: EntitiesRecognizerRequestParams): * {
    let equals = super.equals(model);

    equals &= this.urlParam === model.urlParam;
    equals &= this.langParam === model.langParam;

    return equals;
  }
}
